// @mui
import { useSettingsContext } from 'src/components/settings';
import Card from '@mui/material/Card';
import { Box, Paper, TextField, Grid, Stack, Button, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
// hooks
import { useEffect, useState } from 'react';
// components
import Iconify from 'src/components/iconify';
import { useSelector } from 'react-redux';
import useHeroSection from 'src/hooks/use-homepage-data';
import { useSnackbar } from 'notistack';
import { postRequestForWebsite } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from 'src/services/fetching';

// ----------------------------------------------------------------------

export default function PricePackagesSection() {
  const settings = useSettingsContext();
  const homePageData = useSelector((state) => state.website.homePage);
  const { fetchOnMount } = useHeroSection();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    // Section Headers
    mainTitle: "",
    mainTitleColor: "#333333",
    subtitle: "",
    subtitleColor: "#8BC34A",
    backgroundColor: "#ffffff",

    // Package Cards
    packages: [
      {
        id: 1,
        packageName: "",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "",
        features: [
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" }
        ]
      },
      {
        id: 2,
        packageName: "",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "",
        features: [
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" }
        ]
      },
      {
        id: 3,
        packageName: "",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "",
        features: [
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" }
        ]
      },
      {
        id: 4,
        packageName: "",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "",
        features: [
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" }
        ]
      },
      {
        id: 5,
        packageName: "",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "",
        features: [
          { text: "", color: "#666666" },
          { text: "", color: "#666666" },
          { text: "", color: "#666666" }
        ]
      }
    ],

    // Global Colors
    checkmarkColor: "#8BC34A",
    primaryGreen: "#8BC34A",
    secondaryGreen: "#4CAF50",
    cardBackgroundColor: "#ffffff",
    cardBorderColor: "#e0e0e0"
  });

  const updateFormData = (path, value) => {
    setFormData(prev => {
      const newData = { ...prev };
      const keys = path.split('.');
      let current = newData;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const updatePackage = (packageIndex, field, value) => {
    setFormData(prev => ({
      ...prev,
      packages: prev.packages.map((pkg, i) =>
        i === packageIndex ? { ...pkg, [field]: value } : pkg
      )
    }));
  };

  const updateFeature = (packageIndex, featureIndex, field, value) => {
    setFormData(prev => ({
      ...prev,
      packages: prev.packages.map((pkg, i) =>
        i === packageIndex ? {
          ...pkg,
          features: pkg.features.map((feature, j) =>
            j === featureIndex ? { ...feature, [field]: value } : feature
          )
        } : pkg
      )
    }));
  };

  const addFeature = (packageIndex) => {
    setFormData(prev => ({
      ...prev,
      packages: prev.packages.map((pkg, i) =>
        i === packageIndex ? {
          ...pkg,
          features: [...pkg.features, { text: "New Feature", color: "#666666" }]
        } : pkg
      )
    }));
  };

  const removeFeature = (packageIndex, featureIndex) => {
    setFormData(prev => ({
      ...prev,
      packages: prev.packages.map((pkg, i) =>
        i === packageIndex ? {
          ...pkg,
          features: pkg.features.filter((_, j) => j !== featureIndex)
        } : pkg
      )
    }));
  };

  const addPackage = () => {
    const newId = Math.max(...formData.packages.map(p => p.id)) + 1;
    setFormData(prev => ({
      ...prev,
      packages: [...prev.packages, {
        id: newId,
        packageName: "New Package",
        packageNameColor: "#ffffff",
        packageBannerColor: "#8BC34A",
        link: "/new-package",
        features: [
          { text: "Feature 1", color: "#666666" },
          { text: "Feature 2", color: "#666666" }
        ]
      }]
    }));
  };

  const removePackage = (index) => {
    setFormData(prev => ({
      ...prev,
      packages: prev.packages.filter((_, i) => i !== index)
    }));
  };


   useEffect(() => {
        fetchOnMount();
      }, []);

      useEffect(() => {
        if (homePageData?.price_packages_section) {
          const PricePackagesSection = JSON.parse(JSON.stringify(homePageData.price_packages_section));
          setFormData(prev => ({
            ...prev,
            ...PricePackagesSection
          }));
        }
      }, [homePageData])

  // const handleSave = (isDraft = false) => {
  //   console.log(isDraft ? 'Saving as draft...' : 'Publishing...', formData);

  // };
    const handleSave = async () => {
        setLoading(true);
        try {
          // Create a FormData object for file uploads
          const formDataToSend = new FormData();

          // Append all form data
          Object.entries(formData).forEach(([key, value]) => {
            // Skip heroImage as we'll handle it separately
            if (key !== 'heroImage') {
              // Handle nested objects like primaryButton and secondaryButton
              if (typeof value === 'object' && value !== null && !(value instanceof File)) {
                formDataToSend.append(key, JSON.stringify(value));
              } else {
                formDataToSend.append(key, value);
              }
            }
          });

          // Append the hero image if it exists
          if (formData.heroImage) {
            formDataToSend.append('heroImage', formData.heroImage);
          }

          const response = await postRequestForWebsite(
            endpoints.admin_dashboard.website.home_page.hero_section,
            // formDataToSend,
            // dataForHeroSection,
            {
              attributes: {
                ...JSON.parse(JSON.stringify(homePageData)),
                price_packages_section: JSON.parse(JSON.stringify(formData))
              }
            },
            true
          );

          if (response.metadata?.success) {
            enqueueSnackbar({
              variant: 'success',
              message: response.metadata.message,
            });
          } else {
            handleErrorMessages(response.message || 'An error occurred.');
          }
        } catch (err) {
          console.error('Error:', err);
          handleErrorMessages(err.message || 'Submission failed.');
        } finally {
          setLoading(false);
        }
      };

  const ColorPreview = ({ color, size = 24 }) => (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '4px',
        backgroundColor: color,
        border: '1px solid #ddd',
        display: 'inline-block',
        mr: 1
      }}
    />
  );

  return (
    <Card>
      <CardContent>
        <Typography variant="h4" paragraph>
          Price & Packages Section
        </Typography>

        {/* Section Headers */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Section Headers</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Main Title</Typography>
            <TextField
              fullWidth
              value={formData.mainTitle}
              onChange={(e) => updateFormData('mainTitle', e.target.value)}
              placeholder="Enter main title"
              sx={{ mb: 2 }}
            />
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">Title Color:</Typography>
              <ColorPreview color={formData.mainTitleColor} />
              <TextField
                type="color"
                value={formData.mainTitleColor}
                onChange={(e) => updateFormData('mainTitleColor', e.target.value)}
                sx={{ width: 100 }}
              />
            </Stack>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Subtitle Description</Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={formData.subtitle}
              onChange={(e) => updateFormData('subtitle', e.target.value)}
              placeholder="Enter subtitle description"
              sx={{ mb: 2 }}
            />
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">Subtitle Color:</Typography>
              <ColorPreview color={formData.subtitleColor} />
              <TextField
                type="color"
                value={formData.subtitleColor}
                onChange={(e) => updateFormData('subtitleColor', e.target.value)}
                sx={{ width: 100 }}
              />
            </Stack>
          </Box>

        </Box>



        {/* Packages Management */}
        <Box sx={{ mb: 3, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Package Management</Typography>
          </Stack>

          <Grid container spacing={3}>
            {formData.packages.map((pkg, packageIndex) => (
              <Grid item xs={12} lg={6} xl={4} key={pkg.id}>
                <Paper variant="outlined" sx={{ p: 3, bgcolor: 'background.neutral' }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      Package #{pkg.id}
                    </Typography>
                    {/* <Button
                      color="error"
                      variant="contained"
                      size="small"
                      startIcon={<Iconify icon="mingcute:close-line" />}
                      onClick={() => removePackage(packageIndex)}
                    >
                      Remove
                    </Button> */}
                  </Stack>

                  {/* Package Name */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Package Name</Typography>
                    <TextField
                      fullWidth
                      value={pkg.packageName}
                      onChange={(e) => updatePackage(packageIndex, 'packageName', e.target.value)}
                      placeholder="Enter package name"
                      sx={{ mb: 2 }}
                    />
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Package Link</Typography>
                    <TextField
                      fullWidth
                      value={pkg.link}
                      onChange={(e) => updatePackage(packageIndex, 'link', e.target.value)}
                      placeholder="Enter package link (e.g., /package-details)"
                      sx={{ mb: 2 }}
                    />
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ mb: 1 }}>Text Color</Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <ColorPreview color={pkg.packageNameColor} />
                          <TextField
                            type="color"
                            value={pkg.packageNameColor}
                            onChange={(e) => updatePackage(packageIndex, 'packageNameColor', e.target.value)}
                            sx={{ width: 70 }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ mb: 1 }}>Banner Color</Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <ColorPreview color={pkg.packageBannerColor} />
                          <TextField
                            type="color"
                            value={pkg.packageBannerColor}
                            onChange={(e) => updatePackage(packageIndex, 'packageBannerColor', e.target.value)}
                            sx={{ width: 70 }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Features */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 2 }}>Package Features</Typography>
                    {pkg.features.map((feature, featureIndex) => (
                      <Paper key={featureIndex} variant="outlined" sx={{ p: 2, mb: 2, bgcolor: 'background.paper' }}>
                        <Stack spacing={2}>
                          <TextField
                            fullWidth
                            value={feature.text}
                            onChange={(e) => updateFeature(packageIndex, featureIndex, 'text', e.target.value)}
                            placeholder="Enter feature text"
                            size="small"
                          />
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="body2">Text Color:</Typography>
                              <ColorPreview color={feature.color} size={20} />
                              <TextField
                                type="color"
                                value={feature.color}
                                onChange={(e) => updateFeature(packageIndex, featureIndex, 'color', e.target.value)}
                                sx={{ width: 60 }}
                              />
                            </Stack>
                            <Button
                              color="error"
                              size="small"
                              startIcon={<Iconify icon="mingcute:close-line" />}
                              onClick={() => removeFeature(packageIndex, featureIndex)}
                            >
                              Remove
                            </Button>
                          </Stack>
                        </Stack>
                      </Paper>
                    ))}
                    <Button
                      color="success"
                      variant="outlined"
                      size="small"
                      startIcon={<Iconify icon="mingcute:add-line" />}
                      onClick={() => addFeature(packageIndex)}
                    >
                      Add Feature
                    </Button>
                  </Box>


                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* <Button
            color="success"
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={addPackage}
            sx={{ mt: 3 }}
          >
            Add New Package
          </Button> */}
        </Box>

        {/* Action Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          {/* <Button
            variant="outlined"
            color="inherit"
            onClick={() => handleSave(true)}
          >
            Save as Draft
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            startIcon={<Iconify icon="eva:save-fill" />}
            onClick={() => handleSave(false)}
          >
            Update
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
